export const LOGS_PAGE_VALUES = 'LOGS_PAGE_VALUES';

export const defaultPage = 0;
export const defaultPageSize = 25;
export const defaultSorted = [{ id: 'logRowNumber', desc: true }];
